import React from 'react'
import ReactDOM from 'react-dom/client'
// app.css FIRST, then App (which pulls in the shell CSS) — so the ecosystem shell
// (.block etc.) loads LAST and is the authoritative source of truth. At equal
// specificity the kit then wins over the app's own legacy base rules, instead of
// being silently overridden by them on load order.
import './styles/app.css'
import { ToastProvider } from '@ofself/shell'
import App from './App'
import { ChatProvider } from './contexts/ChatContext'
import { applyChatLayout, readChatLayout } from './chatLayout'
import { applyMsgSize, readMsgSize } from './msgSize'

// Chat preferences on the document before first render, so nothing flickers —
// and so the reading size applies whether or not you ever open Settings.
applyChatLayout(readChatLayout())
applyMsgSize(readMsgSize())

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ToastProvider>
      <ChatProvider>
        <App />
      </ChatProvider>
    </ToastProvider>
  </React.StrictMode>
)
